import React from "react";
import {
  AlertDialogModel,
  EnumAlertDialogType,
} from "../Dashboard/Managers/dataStructures";
import WaitingDialog, {
  AlertWaitingDialog,
} from "../Dashboard/UtilityComponents/WaitingDialog";
import {
  delayCall,
  fetchForgotPasswordCode,
  fetchForgotPasswordReset,
  fetchForgotPasswordValidateCode,
} from "../Dashboard/Managers/wepApiManager";
import { isValiEmail } from "../Dashboard/Managers/utilityFunctions";
import { getEncryptionKey } from "../Dashboard/Managers/profileManager";
import bcrypt from "bcryptjs";
import { getLanguage } from "../Dashboard/Managers/dataProvider";
import CountDownTimer from "../Dashboard/Managers/CountDownTimer";
//import { useNavigate } from "react-router-dom";

interface ForgotPasswordProps {
  close: () => void;
}

export default function ForgotPassword(props: ForgotPasswordProps) {
  const isEnglish = getLanguage();
  const [isActivityRunning, setIsActivityRunning] =
    React.useState<boolean>(false);
  const [userName, setUserName] = React.useState<string>("");
  const [verificationCode, setVerificationCode] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [confirmPassword, setConfirmPassword] = React.useState<string>("");
  const [processState, setProcessState] = React.useState<number>(0);
  const [duration] = React.useState<number>(15 * 60);
  const [alertModel, setAlertModel] = React.useState<AlertDialogModel>({
    type: EnumAlertDialogType.NEUTRAL,
    alert_title: "",
    alert_description: "",
    dismiss_button_text: "",
  });
  //const navigate = useNavigate();

  const btn_text: string =
    processState === 0
      ? isEnglish
        ? "Send Verification Code"
        : "Verfizierungscode versenden"
      : processState === 1
      ? isEnglish
        ? "Confirm Code"
        : "Code bestätigen"
      : processState === 2
      ? isEnglish
        ? "Reset password"
        : "Passwort zurücksetzen"
      : isEnglish
      ? "Proceed"
      : "OK";

  function closeAlert() {
    setAlertModel({
      type: EnumAlertDialogType.NEUTRAL,
      alert_title: "",
      alert_description: "",
      dismiss_button_text: "",
    });
  }

  function onClickHandler() {
    if (processState === 0) {
      if (userName === undefined) {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Please Enter a username."
            : "Bitte geben Sie einen Benutzernamen ein."
        );
      } else if (userName === "") {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Please Enter a username."
            : "Bitte geben Sie einen Benutzernamen ein."
        );
      } else if (isValiEmail(userName) === false) {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Please Enter a valid username."
            : "Bitte geben Sie einen gültigen Benutzernamen ein."
        );
      } else {
        setIsActivityRunning(true);
        fetchForgotPasswordCode(userName, (isSuccess: boolean) => {
          setIsActivityRunning(false);
          if (isSuccess) {
            showAlert(
              true,
              isEnglish ? "Code Sent" : "Verifizierungscode versendet",
              isEnglish
                ? "A verification code is sent to your email."
                : "Ein Code wurde an Ihre E-Mail-Adresse gesendet."
            );
            setProcessState(1);
          } else {
            showAlert(
              false,
              isEnglish ? "Error" : "Fehler",
              isEnglish
                ? "Unable to complete request. Please check your user name"
                : "Anforderung konnte nicht abgeschlossen werden. Bitte überprüfen Sie Ihren Benutzernamen."
            );
          }
        });
      }
    } else if (processState === 1) {
      if (verificationCode === undefined) {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Please Enter the verification code."
            : "Bitte geben Sie den Bestätigungscode ein."
        );
      } else if (verificationCode === "") {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Please Enter the verification code."
            : "Bitte geben Sie den Bestätigungscode ein."
        );
      } else {
        setIsActivityRunning(true);
        fetchForgotPasswordValidateCode(
          userName,
          verificationCode,
          (isSuccess: boolean) => {
            setIsActivityRunning(false);
            if (isSuccess) {
              setProcessState(2);
              showAlert(
                true,
                isEnglish ? "Code confirmed" : "Code bestätigt",
                isEnglish
                  ? "Please enter new password."
                  : "Bitte neues Passwort eingeben."
              );
            } else {
              showAlert(
                false,
                isEnglish ? "Error" : "Fehler",
                isEnglish
                  ? "Unable to complete request. Please enter valid verification code."
                  : "Anfrage konnte nicht abgeschlossen werden. Bitte geben Sie einen gültigen Bestätigungscode ein."
              );
            }
          }
        );
      }
    } else if (processState === 2) {
      if (password === undefined) {
        showAlert(
          false,
          isEnglish ? "Missing Password" : "Missing Password",
          isEnglish
            ? "Please enter new password."
            : "Bitte geben Sie ein neues Passwort ein."
        );
      } else if (confirmPassword === undefined) {
        showAlert(
          false,
          isEnglish ? "Missing Password" : "Missing Password",
          isEnglish
            ? "Please confirm new password."
            : "Bitte bestätigen Sie das neue Passwort."
        );
      } else if (password !== confirmPassword) {
        showAlert(
          false,
          isEnglish ? "Error" : "Fehler",
          isEnglish
            ? "Password don't match."
            : "Passwörter stimmen nicht überein."
        );
      } else {
        setIsActivityRunning(true);
        bcrypt.hash(
          password,
          getEncryptionKey(),
          (herr: Error | null, hash: string) => {
            if (herr == null) {
              fetchForgotPasswordReset(
                userName,
                verificationCode,
                hash,
                (isSuccess: boolean) => {
                  setIsActivityRunning(false);
                  if (isSuccess) {
                    setProcessState(3);
                    setAlertModel({
                      type: EnumAlertDialogType.POSITIVE,
                      alert_title: isEnglish ? "Success" : "Erfolgreich",
                      alert_description: isEnglish
                        ? "Password successfully changed. Routing to Sigin Page"
                        : "Passwort erfolgreich geändert. Weiterleitung zur Anmeldeseite.",
                      dismiss_button_text: "OK",
                    });
                    delayCall(3000, () => {
                      //navigate("/");
                      props.close();
                    });
                  } else {
                    showAlert(
                      false,
                      isEnglish ? "Failure" : "Fehler",
                      isEnglish
                        ? "Failed to change password. Please try again."
                        : "Fehler beim Ändern des Passworts. Bitte versuchen Sie es erneut."
                    );
                  }
                }
              );
            } else {
              showAlert(
                false,
                isEnglish ? "Error" : "Fehler",
                isEnglish
                  ? "Failed to encrypt password"
                  : "Fehler bei der Passwortverschlüsselung"
              );
            }
          }
        );
      }
    }
  }

  function showAlert(isPositive: boolean, title: string, message: string) {
    setAlertModel({
      type: isPositive
        ? EnumAlertDialogType.POSITIVE
        : EnumAlertDialogType.NEGATIVE,
      alert_title: title,
      alert_description: message,
      dismiss_button_text: isEnglish ? "OK" : "OK",
    });
    delayCall(3000, () => {
      setAlertModel({
        type: EnumAlertDialogType.NEUTRAL,
        alert_title: "",
        alert_description: "",
        dismiss_button_text: "",
      });
    });
  }

  function timerExpired() {
    delayCall(2000, () => {
      setProcessState(0);
    });
  }

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div>
        <button
          onClick={props.close}
          type="button"
          className="block rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          //className="text-sm font-semibold leading-6 text-gray-900"
        >
          {isEnglish ? "back" : "Zurück"}
        </button>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        {/* <img alt="" src="" className="mx-auto h-10 w-auto" /> */}
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          {isEnglish ? "Forgot Password" : "Passwort vergessen"}
        </h2>
      </div>
      {alertModel.type !== EnumAlertDialogType.NEUTRAL
        ? AlertWaitingDialog(alertModel, closeAlert)
        : null}
      {isActivityRunning ? WaitingDialog() : null}

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm/6 font-medium text-gray-900"
            >
              {isEnglish ? "Email Address" : "E-Mail Adresse"}
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                disabled={processState > 0 || isActivityRunning ? true : false}
                autoComplete="email"
                onChange={(x) => setUserName(x.currentTarget.value)}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-black/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          {processState > 0 ? (
            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm/6 font-medium text-gray-900"
                >
                  {isEnglish ? "Verification Code" : "Bestätigungscode"}
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="code"
                  name="code"
                  required
                  disabled={
                    processState > 1 || isActivityRunning ? true : false
                  }
                  onChange={(x) => setVerificationCode(x.currentTarget.value)}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-black/10 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
          ) : null}

          {processState > 1 ? (
            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm/6 font-medium text-gray-900"
                >
                  {isEnglish ? "New Password" : "Neues Passwort"}
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  disabled={isActivityRunning}
                  onChange={(x) => setPassword(x.currentTarget.value)}
                  autoComplete="current-password"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-black/10 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
          ) : null}

          {processState > 1 ? (
            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm/6 font-medium text-gray-900"
                >
                  {isEnglish ? "Confirm Password" : "Passwort bestätigen"}
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  disabled={isActivityRunning}
                  onChange={(x) => setConfirmPassword(x.currentTarget.value)}
                  autoComplete="current-password"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-black/10 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
          ) : null}

          <div>
            <button
              type="submit"
              disabled={isActivityRunning}
              onClick={onClickHandler}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {btn_text}
            </button>
          </div>
          {processState === 1 ? (
            <CountDownTimer duration={duration} timerExpired={timerExpired} />
          ) : null}
        </div>
      </div>
    </div>
  );
}
